import {
    UPDATE_ERROR_MSG,
} from '../../../../actionTypes';

export const updateErrorMessage = (message) => {
    return {
        type: UPDATE_ERROR_MSG,
        payload: message
    };
}


// WEBPACK FOOTER //
// ./src/scenes/LoginPage/services/loginFeedback/actions.js